import React from 'react';
import moment from 'moment';
import { Grid } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import { useLocation, useParams } from 'react-router-dom';
import { ModelForm } from '../components';

export default function Invoicereturn({ formMode }) {
	const { id } = useParams();
	const location = useLocation();
	const invoiceId = new URLSearchParams(location.search).get('invoiceId');
	const [defaultValues] = React.useState(() =>
		id
			? {}
			: {
					invoiceId: invoiceId || '',
					returnDate: moment().toISOString()
			  }
	);
	const redirectionPathMap = {
		list: '/invoicereturns',
		view: `/invoicereturn/${id}`,
		edit: `/invoicereturn/${id}/edit`,
		created: record => `/invoicereturn/${record.id}`
	};

	return (
		<Grid container>
			<ModelForm
				key={location.key}
				recordId={id}
				formName={'invoiceReturnLayout'}
				defaultValues={defaultValues}
				initialMode={formMode}
				isDraftable={true}
				redirectionPathMap={redirectionPathMap}
				customActionButtons={[
					{
						text: 'Print',
						startIcon: <PrintIcon />,
						color: 'primary',
						display(form) {
							return form.values.id && form.mode === 'view';
						},
						href: `/invoicereturn/download/${id}`,
						target: '_blank'
					}
				]}
			/>
		</Grid>
	);
}
